import Vue from 'vue';
import App from './App.vue';
import store  from './store';
import router from './router';
import http from './http';
import VueSilentbox from 'vue-silentbox';
Vue.use(VueSilentbox)
import FlashMessage from '@smartweb/vue-flash-message';
Vue.use(FlashMessage)
import _ from 'lodash';
Vue.prototype._ = _
if (localStorage.getItem("session_id") === null) {
  localStorage.setItem('session_id', new Date().valueOf());
}

import VueSocialSharing from 'vue-social-sharing'
Vue.use(VueSocialSharing)

import helper from './helper/utils';
Vue.use({
  install() {
      Vue.helper = helper;
      Vue.prototype.$helper = helper;
  }
});

Vue.prototype.$http = http

// const auth = axios.create({
//   baseURL: process.env.VUE_APP_APIURL,
//   headers: {
//       'Authorization': 'Bearer '+localStorage.getItem('token'),
//   }
// })
// Vue.prototype.$authHttp = auth

// auth.interceptors.response.use(
//   (res) => {
//     return res;
//   },
//   async (err) => {
//     const originalConfig = err.config;
//     if (originalConfig.url !== "/login" && err.response) {
//       if (err.response.status === 401 && !originalConfig._retry) {
//         originalConfig._retry = true;
//         try {
//           window.location.href = "/login"
//         } catch (_error) {
//           return Promise.reject(_error);
//         }
//       }
//     }
//     return Promise.reject(err);
//   }
// );

Vue.config.productionTip = false;
Vue.DOMAIN = Vue.prototype.APIURL = process.env.VUE_APP_DOMAIN;
Vue.APIURL = Vue.prototype.APIURL = process.env.VUE_APP_APIURL;
Vue.IMAGEURL = Vue.prototype.IMAGEURL = process.env.VUE_APP_IMAGEURL;
Vue.baseUrl = Vue.prototype.baseUrl = process.env.VUE_APP_BASEURL;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount(`#app`);
